import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { InputLabel } from '@material-ui/core';
import { InputProps } from './types';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import QuestionnaireSelector from '../QuestionnaireSelector/QuestionnaireSelector';
import { ErrorMessage } from '../Services/styled-components';

interface ReturningQuestionnaireSelectorEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  returningQuestionnaireId?: string;
}

function ReturningQuestionnaireSelectorEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  returningQuestionnaireId,
}: ReturningQuestionnaireSelectorEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel error={Boolean(fieldState.error)}>Returning questionnaire</InputLabel>
          <QuestionnaireSelector value={value || returningQuestionnaireId} onChange={onChange} />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default ReturningQuestionnaireSelectorEditor;
